import api from './api';

// Interface base para Setor
export interface Setor {
  id: number;
  nome: string;
  dataremocao?: string;
  idmongodb?: string;
  principal_id?: number;
}

// Interface para criação de Setor
export interface SetorCreate {
  nome: string;
  principal_id?: number;
  idmongodb?: string;
}

// Interface para atualização de Setor
export interface SetorUpdate {
  nome?: string;
  principal_id?: number;
  idmongodb?: string;
}

// Interface para filtros de busca
export interface SetorFilter {
  nome?: string;
  principal_id?: number;
}

const SetoresService = {
  // Obter lista de setores com filtragem e paginação
  getSetores: async (filter: SetorFilter = {}, skip: number = 0, limit: number = 10): Promise<Setor[]> => {
    try {
      const response = await api.get('/setores/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar setores:', error);
      throw error;
    }
  },

  // Obter setor por ID
  getSetorById: async (id: number): Promise<Setor> => {
    try {
      const response = await api.get(`/setores/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar setor ${id}:`, error);
      throw error;
    }
  },

  // Criar novo setor
  createSetor: async (setor: SetorCreate): Promise<Setor> => {
    try {
      const response = await api.post('/setores/', setor);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar setor:', error);
      throw error;
    }
  },

  // Atualizar setor existente
  updateSetor: async (id: number, setor: SetorUpdate): Promise<Setor> => {
    try {
      const response = await api.put(`/setores/${id}`, setor);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar setor ${id}:`, error);
      throw error;
    }
  },

  // Excluir setor
  deleteSetor: async (id: number): Promise<void> => {
    try {
      await api.delete(`/setores/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir setor ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getSetoresCount: async (filter: SetorFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/setores/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de setores:', error);
      throw error;
    }
  },
  
  // Obter todos os setores (para dropdown/select)
  getAllSetores: async (): Promise<Setor[]> => {
    try {
      const response = await api.get('/setores/all/list');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar lista de setores:', error);
      throw error;
    }
  }
};

export default SetoresService;
